import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';

@Component({
  selector: 'unicon-speedometer-card',
  templateUrl: './speedometer-card.component.html',
})
export class SpeedometerCardComponent {
  @Input() title: string = '';
  @Input() value: number = 0;
  @Input() measurementUnit: string = 'min';

  protected doughnutChartData: ChartData<'doughnut'> = {
    labels: ['Red', 'Yellow', 'Green'],
    datasets: [
      {
        label: 'My First Dataset',
        data: [100, 100, 100],
        backgroundColor: ['#FA0A32', '#F7CD46', '#31DB0C'],
        hoverOffset: 0,
        circumference: 180,
        rotation: 270,
        offset: 0,
      },
    ],
  };

  protected doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    cutout: '80%',
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false },
    },
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1.5,
    layout: {
      padding: {
        top: 0,
        bottom: 0,
      },
    },
  };
}
